export default "__VITE_ASSET__BiFW9B_J__"